import React from 'react'
import { Grid } from '@chakra-ui/react'

export default (props) => {
  return <Grid {...props} />
}
